import React from "react"
import { Button } from "@mui/material"
import LoadingButton from "@mui/lab/LoadingButton"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import i18n from "@/i18n"
import { STYLES } from "./_styles"

interface FooterProps {
  canGoNext: boolean
  loading: boolean
  onBack: () => void
  onNext: () => void
  backLabel?: string
  nextLabel?: string
  hideBackButton?: boolean
  containerClassName?: string
  showTopBorder?: boolean
  children?: React.ReactNode
}

const Footer: React.FC<FooterProps> = ({
  canGoNext,
  loading,
  onBack,
  onNext,
  backLabel = i18n.t("app.public.venue.modal.back"),
  nextLabel = i18n.t("app.public.venue.modal.next"),
  hideBackButton = false,
  containerClassName = "",
  showTopBorder = true,
  children,
}) => {
  const footerClassName = [STYLES.footerContainer, showTopBorder ? "border-t border-[#e5e6ec]" : "", containerClassName]
    .filter(Boolean)
    .join(" ")

  return (
    <div
      className={footerClassName}
      data-testid="public-reservation-modal-footer-container"
      style={showTopBorder ? undefined : { borderTop: 0 }}
    >
      <div className={STYLES.footerLeft}>
        {!hideBackButton && (
          <Button
            variant="outlined"
            color="inherit"
            onClick={onBack}
            disabled={loading}
            startIcon={<ArrowBackIcon />}
            size="small"
            data-testid="public-reservation-modal-footer-back-btn"
            sx={{
              borderColor: "#e5e7eb",
              color: "#201f1f",
              textTransform: "none",
              fontSize: "12px",
              backgroundColor: "#ffffff",
              "& .MuiButton-startIcon": {
                color: "#6b7280",
              },
              "& .MuiSvgIcon-root": {
                color: "#6b7280",
              },
              "&:hover": {
                borderColor: "#d1d5db",
                backgroundColor: "#ffffff",
              },
            }}
          >
            {backLabel}
          </Button>
        )}
        {children}
      </div>
      <LoadingButton
        variant="contained"
        onClick={onNext}
        disabled={!canGoNext}
        loading={loading}
        size="small"
        data-testid="public-reservation-modal-footer-next-btn"
        sx={{
          backgroundColor: "#2596fa",
          borderRadius: "5px",
          textTransform: "none",
          fontSize: "12px",
          "&:hover": { backgroundColor: "#1e7cd8" },
          "&.Mui-disabled": { backgroundColor: "#2596fa", opacity: 0.5 },
        }}
      >
        {nextLabel}
      </LoadingButton>
    </div>
  )
}

export default Footer
